import React from 'react'
import PropTypes from 'prop-types'
import { compose, pure } from 'recompose'
import EditorLimitTextField from '../../molecules/EditorLimitTextField/EditorLimitTextField'
import { QuestionType } from '../../../../commons/EditorStatus'
import './EditChoice.css'

export const imageStatus = image => {
  let status = ''
  image != '' ? (status = image.match(/[^/]+$/)[0].split('?')[0]) : (status = '画像をアップロード')
  return status
}

const EditChoice = ({
  index,
  choiceText,
  answerChoiceId,
  choiceImage,
  onChangeChoiceText,
  onChangeAnswerChoice,
  toggleImageUploadModal,
  selectedQuestionType,
  showRadioButton
}) => (
  <div styleName="container">
    <div styleName="section">
      <div styleName="flex-container">
        <div styleName="text-flex-container">
          <EditorLimitTextField
            index={index}
            text={choiceText}
            limitLength={30}
            choiceImage={choiceImage}
            answerChoiceId={answerChoiceId}
            showLimitCount={true}
            showImage={!(selectedQuestionType === QuestionType.TRUEFALSE.value)}
            showRadioButton={showRadioButton}
            onChangeText={onChangeChoiceText}
            onChangeAnswerChoice={onChangeAnswerChoice}
            onClickImage={() => toggleImageUploadModal(index)}
          />
        </div>
      </div>
    </div>
  </div>
)

EditChoice.propTypes = {
  index: PropTypes.number,
  choiceText: PropTypes.string,
  choiceId: PropTypes.number,
  answerChoiceId: PropTypes.number,
  choiceImage: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onChangeChoiceText: PropTypes.func,
  onUploadImage: PropTypes.func,
  onChangeAnswerChoice: PropTypes.func,
  toggleImageUploadModal: PropTypes.func,
  selectedQuestionType: PropTypes.number,
  showRadioButton: PropTypes.bool
}

EditChoice.defaultProps = {
  choiceImage: ''
}

export default compose(pure)(EditChoice)
